<template>
  <section class="bg-gray-50 py-20 sm:py-28">
    <div class="container mx-auto px-4">

      <div class="text-center max-w-3xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
          Sua operação em ordem, sua equipe<br />conectada e seu cliente sempre informado.
        </h2>
      </div>

      <div class="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        <div 
          v-for="item in companyInfo" 
          :key="item.title"
          class="bg-white rounded-2xl p-8 text-center border border-gray-200 
                 transition-all duration-300 hover:border-orange-500 hover:shadow-2xl hover:-translate-y-2 cursor-pointer"
        >
          
          <div class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-orange-100">
            <span class="material-symbols-outlined text-4xl text-orange-600">
              {{ item.iconName }}
            </span>
          </div>
          
          <h3 class="mt-6 text-2xl font-bold text-gray-900">{{ item.title }}</h3>
          
          <div class="mt-4 text-base text-gray-600 leading-relaxed">
            <p v-if="item.type === 'paragraph'">
              {{ item.description }}
            </p>
            <ul v-if="item.type === 'list'" class="space-y-2 text-left">
              <li v-for="value in item.description" :key="value" class="flex items-start">
                <span class="text-orange-500 mr-3 mt-1.5 flex-shrink-0 text-xs">◆</span>
                <span>{{ value }}</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModernValuesSectionMaterial',
  data() {
    return {
      companyInfo: [
        {
          title: 'Missão',
          type: 'paragraph',
          description: 'Impulsionar negócios de alimentação com uma gestão de pedidos eficiente, conectada e estratégica.',
          iconName: 'track_changes',
        },
        {
          title: 'Visão',
          type: 'paragraph',
          description: 'Ser a plataforma referência em performance operacional e experiência digital para o setor de delivery e food service na América Latina.',
          iconName: 'visibility',
        },
        {
          title: 'Valores',
          type: 'list',
          description: [
            'Parceria real e contínua',
            'Suporte humano e próximo',
            'Inovação que simplifica',
            'Clareza, leveza e resultado',
            'Foco total no cliente',
          ],
          iconName: 'diamond',
        },
      ],
    };
  },
}
</script>